import { useCallback, useMemo } from 'react'
import { stringify } from 'query-string'
import { useSelector } from 'react-redux'
import { companySelector } from 'app-redux/selectors'
import { getExpiresAt, getRefreshExpiresAt, getRefreshToken, getToken } from 'utils/cookies'
import { ensureFreshToken } from 'utils/axios'

// Hook untuk handle url handoff ke aplikasi gajihub
const useUrlGajihub = () => {
  const { selectedEndpoint, website_id: websiteId } = useSelector(companySelector)

  const buildUrlGajihub = useCallback(
    (token) => {
      const searchs = {
        token,
        website_id: websiteId,
        endpoint: selectedEndpoint,
        refresh_token: getRefreshToken(),
        refresh_expires_at: getRefreshExpiresAt(),
        expires_at: getExpiresAt(),
      }
      return `${import.meta.env.VITE_GAJIHUB_URL}/dashboard?${stringify(searchs, {
        skipNull: true,
      })}`
    },
    [selectedEndpoint, websiteId],
  )

  // Dipakai sebagai href (fallback middle-click / buka di tab baru)
  const urlGajihub = useMemo(() => buildUrlGajihub(getToken()), [buildUrlGajihub])

  // Dipakai saat klik: pastikan token terbaru (refresh dulu jika hampir/sudah expired)
  // supaya gajihub tidak menerima token kadaluarsa dan meminta login ulang
  const getFreshUrlGajihub = useCallback(async () => {
    const token = await ensureFreshToken()
    if (!token) {
      return null
    }
    return buildUrlGajihub(token)
  }, [buildUrlGajihub])

  return { urlGajihub, getFreshUrlGajihub }
}

export default useUrlGajihub
